/* eslint-disable */
import React, { memo, useEffect, useMemo, useState } from 'react';
import { Badge } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { useFilters } from '../../../providers/Filters/useFilters';
import { TabsPills } from '../../../components/TabsPills'
import { Badge as SkeletonBadge } from '../../../components/Skeleton';
import { Flex } from '../../../components/Layout';

const FilterStatuses = ({ filterMethod, statuses }) => {
  const { filters, onDeleteFilter, onChangeFilter } = useFilters();
  const filter = filters[filterMethod];

  const [activeStatus, setActiveStatus] = useState(filter?.status || null);

  const isSkeleton = statuses.some(item => item?.skeleton === true);

  const tabsData = useMemo(() => {
    if (statuses?.length) {
      return statuses.map((status) => {
        if (status.skeleton || isSkeleton) {
          return {
            ...status,
            isLoading: status.skeleton ? true : !!status.count
          }
        }
        return status;
      })
    }
    return []
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statuses, isSkeleton])

  const onChangeStatus = (status) => {
    if (activeStatus !== status.id) {
      setActiveStatus(status.id)
    }
  }

  const onClearStatus = () => {
    setActiveStatus(null)
  }

  useEffect(() => {
    const filterStatus = filter.hasOwnProperty('status') ? filter.status : null;
    if (activeStatus !== filterStatus) {

      if (activeStatus === null) {
        onDeleteFilter(['status', 'page']);
        return;
      }
      onChangeFilter({
        [filterMethod]: {
          status: activeStatus
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStatus])

  useEffect(() => {
    const filterStatus = filter.hasOwnProperty('status') ? filter.status : null;

    if (filterStatus !== activeStatus) {
      setActiveStatus(filterStatus);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.status]);

  if (!statuses.length) {
    return null;
  }

  return (
    <TabsPills.Root>
      <TabsPills.Item
        onClick={onClearStatus}
        active={activeStatus === null}
      >
        All
      </TabsPills.Item>
      {tabsData.map((status, index) => {
        const isActiveStatus = activeStatus !== null && Number(status.id) === Number(activeStatus);
        return (
          <TabsPills.Item
            title={status.title}
            active={isActiveStatus}
            onClick={() => {
              if (!isActiveStatus) {
                onChangeStatus(status)
              }
            }}
            key={`status-${index}`}
          >
            <Flex gap={4} align={'center'}>
              <span>{status.title}</span>
              {status.isLoading ? <SkeletonBadge /> : !!status.count && Number(status.count) > 0 && (
                <Badge className={status.code === 'error' || status.code === 'fail' ? 'badge-error' : ''}>{status.count}</Badge>
              )}
            </Flex>
          </TabsPills.Item>
        )
      })}
    </TabsPills.Root>
  )
}

FilterStatuses.defaultProps = {
  statuses: [],
  filterMethod: 'query',
};

FilterStatuses.propTypes = {
  statuses: PropTypes.array,
  filterMethod: PropTypes.string,
};

export default memo(FilterStatuses);
